import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getMasteryDisplay } from '../../../utils/skills'
import { getWorkSkillTierDisplay } from '../../../utils/workskills'
import { Caption4 } from '../../styled/typography/typography'

const Mastery = styled(Caption4)`
  width: ${props => props.width ? props.width : '100px'};
  padding: 3px 2px;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  font-weight: ${props => props.light ? 300 : 500};
  border-radius: 3px;
  border: ${props => props.border ?? 'none'};
  text-align: center;
`

const MasteryLevel = ({
  masteryRating,
  workSkill,
  isMentor,
  width,
  rawValue,
  needsAggregateCutoffAdjustment
}) => {
  const display = workSkill
    ? getWorkSkillTierDisplay(masteryRating, workSkill, isMentor, needsAggregateCutoffAdjustment)
    : getMasteryDisplay(masteryRating, isMentor, needsAggregateCutoffAdjustment)

    return (
    <Mastery
      bgColor={display.color}
      textColor={display.contrastColor}
      light={display.light}
      border={display.border}
      width={width}
      data-mastery={rawValue === null ? 'not started' : rawValue}
    >
      {display.name}
    </Mastery>
  )
}

MasteryLevel.propTypes = {
  masteryRating: PropTypes.number.isRequired,
  workSkill: PropTypes.object
}

export default MasteryLevel
